import React,{ useEffect, useRef, useState } from 'react'
import "./Invoice.scss";
import InvoiceTable from '../../../../components/APC/Invoice/InvoiceTable';
import drapeau from "../../../../assets/images/drapeau.png";
import qrcode from "../../../../assets/images/qrcode.svg";
import branding from "../../../../assets/images/branding.png";
import simandou from "../../../../assets/images/simandou.png";
import { useReactToPrint } from 'react-to-print';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import Api from '../../../../services/Api';
import Erreurs from '../../../../components/Erreurs/Erreurs';
import moment from 'moment';
import { useContext } from 'react';
import { UserContext } from '../../../../services/Context/Context';
import { useNavigate } from 'react-router-dom';
import DocumentTitle from '../../../../components/DocumentTitle/DocumentTitle';
const Invoice = () => {
    const { id } = useParams();
    const componentRef = useRef();
    const[ isLoading, setIsLoading ] = useRecoilState(loadingState);
    const url = process.env.REACT_APP_URL.replace('api/','') + 'storage/';  
    const data = useContext(UserContext);
    const navigate = useNavigate();
    const api = new Api();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: `
          @page {
            size: A4;
            margin: 0;
          }
          @media print {
            body, html {
              width: 210mm;
              height: 297mm;
              margin: 0 !important;
              padding: 0 !important;
            }
            .print-btn {
              display: none !important;
            }
            * {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `,
      });
    
    //   const { data } = useQuery({
    //     queryKey: ['invoice', id],
    //     queryFn: () => getInvoice(id)
    //   });
   
  const[paiementData, setPaiementData] = useState([]);
  const [erreurs, setErreurs] = useState([]);

  useEffect(() => {
    const fetchPaiementData = async () => {
        try{
            setIsLoading(true);setPaiementData([]);setErreurs([]);
         
            const { status,errors,data } = await api.apiData('get',`/paiement/apc/invoice?invoice_id=${id}`);
            //console.log(data)
            if(status == 200){
                setPaiementData(data);
            }
            else{
                setErreurs(errors);
            }
            // setPaiementData(response.data);
        }catch(error){
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    }
    fetchPaiementData();
  }, [id]);

  return (
    <div className='invoice-container page'>
     <DocumentTitle title="Facture de Paiement de AEP" />
     { (paiementData.length > 0 && !isLoading )? 
       <>  
          <Erreurs erreurs={erreurs} />
          <div className="print-button-container">
              <button className="print-button" onClick={handlePrint}>Imprimer</button>
              {data?.user && (
               <button className="secondary" onClick={() => navigate("/apc/nouvelle")}>Nouveau</button>
              )}
          </div>
          <div className="invoice-content" ref={componentRef}>
                <div className="invoice-content__header">
                <div className='invoice-content__logo'>
                <img src={url + paiementData[0]?.agencelogo } alt="logo" />
                    <p>{ paiementData[0]?.agence }</p>
                </div>
                <p className='invoice-content__title'>Facture</p>
                <div className='invoice-content__meta'>
                    <span>Facture No.: { paiementData[0].groupID }</span>
                    <span>Facture Date: { moment(paiementData[0].createdAt).format("DD/MM/YYYY") }</span>
                </div>
                <h3>Attestation d'enregistrement primaire </h3>
                </div>
                <div className='invoice-content__body'>
                    <div className='invoice-content__info'>
                        <div className='invoice-content__payment'>
                            <div className='payment__info'>
                                <p><strong>Payment info:</strong></p>
                                <p>{ paiementData[0]?.prefecture !== paiementData[0]?.commune ? paiementData[0]?.prefecture + "," + paiementData[0]?.commune + "," + paiementData[0]?.quartier : paiementData[0]?.commune + "-" + paiementData[0]?.quartier }</p>
                                <p>Telephone: 624 37 31 14</p>
                                <p>Agent: <strong>{ paiementData[0]?.agentFirstName + " " + paiementData[0]?.agentLastName }</strong></p>
                            </div>
                            <div className="payment_client">
                                <p className='client-name'>{ paiementData[0].fullName }</p>
                                <p>{ paiementData[0].adresse }</p>
                                <p><strong>CNI/Passport:</strong> { paiementData[0].nina }</p>
                                <p><strong>Téléphone:</strong> { paiementData[0].telephone }</p>
                            </div>
                        </div>
                        
                    </div> 
                    <div className='invoice-content__body__detailsvehicule'>
                        <div className='invoice-content__body__content__body__detailsvehicule__header'>
                            <h2>Informations du véhicule</h2>
                        </div>
                        <div className='invoice-content__body__content__body__detailsvehicule__body'>
                            <p><strong>Marque: </strong> { paiementData[0].marqueName }</p>
                            <p><strong>Modèle: </strong>{ paiementData[0].modeleName }</p>
                            <p><strong>Categorie:</strong> { paiementData[0].categorie }</p>
                            <p><strong>Couleur:</strong> { paiementData[0].couleur.charAt(0).toUpperCase() + paiementData[0].couleur.slice(1) || paiementData[0].otherColor.charAt(0).toUpperCase() + paiementData[0].otherColor.slice(1) || "Non fourni" }</p>
                        </div>
                    </div>
                    <InvoiceTable
                      descriptionData={ paiementData }
                    />
                </div>
                <div className='invoice-content__footer'>
                    <div className='invoice-content__footer__left'>
                    <div className='invoice-content__footer__left__drapeau'>
                        <img src={drapeau} alt="drapeau" />
                    </div>
                    <div className='invoice-content__footer__left__divider'>
                    </div>
                    <div className='invoice-content__footer__left__qrcode'>
                        <img src={ url + paiementData[0].qrcodeInvoice } alt="qrcode" />
                    </div>
                    </div>
                    <div className='invoice-content__footer__center'>
                    <p>RCCM/GC-KAL/071 616B/2016, Nif: 036856K, N°Cpte :0010124621929301 Ecobank</p> 
                    <p>Siège: Cameroun C/Dixinn, Tél:+224 624 37 31 14, E-mail: info@sipimguinee.com</p> 
                    <p>DSD Guinée © 2025. Tous droits réservés</p>
                    </div>
                    <div className='invoice-content__footer__right'>
                        <div className='invoice-content__footer__right__branding'>
                            <img src={branding} alt="branding" />
                        </div>
                        <div className='invoice-content__footer__right__simandou'>
                            <img src={simandou} alt="simandou" />
                        </div>
                    </div>
                </div>
          </div> 
        </>   
      :
      <div className='invoice-content__notfound'>
        <p>Aucune facture trouvée</p>
      </div>
      }

    </div>
  )
}

export default Invoice